import React from 'react'
import * as Yup from 'yup';
import { Button, Card, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faBell, faEdit } from '@fortawesome/free-regular-svg-icons';
import { Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { faAdd, faCancel, faCheck, faSave, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
// import { AppDispatch, RootState } from '../../store';
import { useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { AESDecrypt, AESEncrypt, encryptAndEncode } from '../../../encrypt-util';
import { updateDashbaordRefresh } from '../../common/components/DataTable/slices/DataTable';
import useDataCountry from '../../../hooks/useDataCountry';
import { getBlLocationList, getBlTypeList, getNewBlRequestAttConf, getNewBlRequestDetails, submitBlRequest, approvereject, getLatestBlRequestIdByBlNo } from './NewBlRequestActions';
import { useLinerConfig } from '../../../hooks/useLinerConfig';
import { AppDispatch, RootState } from '../template/store';
import { getDateFormat } from '../../../helpers/dateFormat';
import DataTable from '../../common/components/DataTable';
import { IDataTableColumn } from '../../common/types/dataTable';
import { addDocument, clearFields, removeDocument, updateAdttamentData, updateLinerAttachmentId, updateListByRowNumber, updateSelectedAttachmentFilePath, updateSelectedAttachmentName, updateSelectedFileServerPath, updateSelectedLinerAttachmentFilePath, updateSelectedLinerAttachmentName, updateSelectedLinerDocId, updateSelectedLinerFileServerPath } from './NewBlRequestSlice';
import UploadThing from '../../../components/common/UploadThing';
import { openDocumentInNewTab } from '../../../helpers/openDocumentInNewTab';


const NewBlRequest = () => {

    const { newblid } = useParams();
    const newBlIdDecrypt = AESDecrypt(newblid) ?? '';
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const dataCountry = useDataCountry();


    const { t } = useTranslation();
    const [clearable, setClearable] = useState(true);

    const [isRegisteredEmailDisabled, setIsRegisteredEmailDisabled] = useState(false);
    const [loadingLinerFileState, setLoadingLinerFileState] = useState<number | undefined>(undefined)
    // const [actionType, setActionType] = useState("");
    const rbac = useSelector((state: RootState) => state.userProfile);
    const selectedLinerId = useSelector(
        (state: RootState) => state.navbarTop.linerId
    );

    const serverFilePath = useSelector(
        (state: RootState) => state.newBlRequest.selectedFileServerPath
    );
    const docAttachment = useSelector(
        (state: RootState) => state.newBlRequest.attData
    );
    const documentList = useSelector(
        (state: RootState) => state.newBlRequest.attData.list
    );

    const selectedAttachmentFilePath = useSelector(
        (state: RootState) => state.newBlRequest.selectedAttachmentFilePath
    );

    const selectedAttachmentName = useSelector(
        (state: RootState) => state.newBlRequest.selectedAttachmentName
    );

    const selectedDocId = useSelector(
        (state: RootState) => state.newBlRequest.selectedDocId
    );

    const selectedLinerAttachmentFilePath = useSelector(
        (state: RootState) => state.newBlRequest.selectedLinerAttachmentFilePath
    );
    const selectedLinerAttachmentName = useSelector(
        (state: RootState) => state.newBlRequest.selectedLinerAttachmentName
    );
    const selectedLinerFileServerPath = useSelector(
        (state: RootState) => state.newBlRequest.selectedLinerFileServerPath
    );

    const linerAttachmentId = useSelector(
        (state: RootState) => state.newBlRequest.linerAttachmentId
    );

    const [shipmentTypeList, setShipmentTypeList] = useState<any>();
    // const [blCopyTypeList, setBlCopyTypeList] = useState<any>();

    const [blTypeList, setBlTypeList] = useState<any>();
    console.log(blTypeList, "ii");
    const [blLocationList, setBlLocationList] = useState<any>();
    // const [showLockerPin, setShowLockerPin] = useState(false);
    const [loadingFileState, setLoadingFileState] = useState<{
        [key: string]: number;
    }>({});
    const [isEdit, setIsEdit] = useState(false);
    console.log(loadingFileState, "loadingFileState")

    const docList = useSelector((state: RootState) => state.newBlRequest.docList);
    const dropdownDocList = useSelector((state: RootState) => state.newBlRequest.dropdownDocList);
    const currentDocList = docList ?? [];
    const dropdownDocId = (dropdownDocList ?? []).map((i: any) => i.id);
    const additionalDocCount = ((currentDocList?.filter((i: any) => (dropdownDocId?.includes(i.id)))?.length ?? 0))

    const profileDetails = useSelector(
        (state: RootState) => state.userProfile.profile
    );

    type FormValues = {
        bookingNumber: string;
        blNumber: string;
        registeredEmailAddress: string;
        shipmentType: string;
        blType: string;
        blLocation: string;
        agentName: string;
        agentNumber: string;
        email: string;
        linerRemarks: string;
        lockerPin: string;
        lockerUnit: string;
        validTill: string;
        status: string;
        blCopyType: string;
        releaseToCustomer: "Y" | "N";
        actionType: string;

    };

    const validationSchema = Yup.object({

        bookingNumber: Yup.string()
            .notRequired()
            .test(
                "is-8-digit-number",
                "Booking No. must be exactly 8 digits",
                (value) => !value || /^\d{8}$/.test(value)
            ),
        // blNumber: Yup.string()
        //     .required("BL Number is required")
        //     .matches(/^HLCU\d{12}$/, "B/L No. must start with HLCU followed by 12 digits")
        //     .length(16, "B/L No. must be exactly 16 characters"),
        blNumber: Yup.string()
            .required("BL Number is required")
            .matches(
                /^HLCU[a-zA-Z0-9]{12}$/,
                "B/L No. must start with HLCU followed by 12 alphanumeric characters"
            )
            .length(16, "B/L No. must be exactly 16 characters"),

        blType: Yup.string()
            .required('Please select B/L Type'),
        blLocation: Yup.string()
            .required('Please select B/L Location'),
        agentName: Yup.string()
            .required('Customer’s Name is required').matches(/^[A-Za-z ]+$/, "Customer’s Name must contain only alphabets"),

        agentNumber: Yup.string()
            .required(" Customer's Contact No. is required")
            .matches(/^[0-9+\-\s]*$/, " Customer's Contact No. can only contain numbers, spaces, + and -"),

        email: Yup.string()
            .required("Customer Email is required")
            .test(
                "non-empty",
                "Customer Email is required",
                (value) => !!value && value.trim() !== ""
            ),


        blCopyType: Yup.string().when("actionType", {
            is: (actionType: string) =>
                profileDetails.partnerType == "liner" && actionType == "A",
            then: (schema) => schema.required("BL Type is required"),
            otherwise: (schema) => schema.notRequired()
        }),

        linerRemarks: Yup.string()
            .max(500, "Liner Remarks must be maximum 500 characters")
            .when("actionType", {
            is: (actionType: string) =>
                profileDetails.partnerType == "liner" && (actionType == "R" || actionType == "N"),
            then: (schema) => schema.required("Rejection Remarks is required"),
            otherwise: (schema) => schema.notRequired()
        }),

       
        lockerPin: Yup.string()
            .transform((v) => (v == null || v === undefined ? "" : String(v)))
            .test("pin-format", "PIN must be maximum 10 digits", (value?: string) => {
                const pin = (value ?? "").trim();
                if (!pin) return true;
                return /^\d+$/.test(pin) && pin.length <= 10;
            })
            .when(["blType", "actionType"], {
                is: (blType: string, actionType: string) =>
                    Number(blType) === 3 && actionType === "A",
                then: (schema) => schema.required("Locker PIN is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

        validTill: Yup.string()
            .transform((v) => (v == null || v === undefined ? "" : String(v)))
            .when(["blType", "actionType"], {
                is: (blType: string, actionType: string) =>
                    Number(blType) === 3 && actionType === "A",
                then: (schema) => schema.required("PIN Validity is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

        lockerUnit: Yup.string()
            .transform((v) => (v == null || v === undefined ? "" : String(v)))
            .max(500, "Locker unit must be at most 500 characters")
            .when(["blType", "actionType"], {
                is: (blType: string, actionType: string) =>
                    Number(blType) === 3 && actionType === "A",
                then: (schema) => schema.required("Locker Unit is required"),
                otherwise: (schema) => schema.notRequired(),
            }),


        registeredEmailAddress: Yup.string().when("actionType", {
            is: (actionType: string) =>
                profileDetails.partnerType == "liner" && (actionType == "A" || actionType == "N"),

            then: (schema) =>
                schema
                    .required("Registered Email Address is required")
                    .test(
                        "is-valid-registered-email",
                        "One or more registered email addresses are invalid",
                        (value) => {
                            if (!value) return false;

                            const trimmedValue = value.trim();

                            if (trimmedValue.startsWith(",") || trimmedValue.endsWith(",")) {
                                return false;
                            }


                            // Split, trim, remove empty
                            const emails = trimmedValue
                                .split(",")
                                .map((e) => e.trim())
                                .filter((e) => e !== "");

                            if (emails.length === 0 || emails.some((e) => e === "")) {
                                return false;
                            }

                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            return emails.every((e) => emailRegex.test(e));


                        }
                    ),

            otherwise: (schema) => schema.notRequired()
        }),

    });

    console.log(selectedLinerAttachmentName, "-", selectedLinerFileServerPath, "test45")

    const handleApprove = async () => {


        // setActionType("A");

        setValue("actionType", "A");

        clearErrors(["linerRemarks"]);
        // await new Promise((resolve) => setTimeout(resolve, 0));
        // trigger([ "registeredEmailAddress", "validTill"]);
        // trigger([ "registeredEmailAddress", "validTill"]).then(() => clearErrors(["linerRemarks"]));

        const isObl = Number(watch("blType")) === 3;
        const isValid = await trigger(
            isObl
                ? ["registeredEmailAddress", "lockerPin", "validTill", "lockerUnit"]
                : ["registeredEmailAddress"]
        );
        if (!isValid) return;

        // const payorRegisteredEmailArray = watch("registeredEmailAddress")
        //     ? watch("registeredEmailAddress")
        //         .split(",")
        //         .map((e) => e.trim())
        //         .filter((e) => e !== "")
        //     : [];

        const loadingCheck = loadingLinerFileState != undefined && loadingLinerFileState != 100 && loadingLinerFileState != 0 && loadingLinerFileState != -1
        const docMandateCheck = (loadingLinerFileState != 100 || !selectedLinerAttachmentName)
        if (loadingCheck || (blCopyMandatory && docMandateCheck)) {
            toast.dark('Please upload BL file to proceed');
            return;
        }

        const payload = {
            blId: newBlIdDecrypt,
            // validTill: watch("validTill")
            //     ? moment(watch("validTill")).utc(true).format()
            //     : null,
            // Locker fields should apply only for OBL (codeId=3)
            validTill: watch("validTill") ,
            lockerPin:  watch("lockerPin") ,
            lockerUnit:  watch("lockerUnit") ,
            blCopyType: watch("blCopyType"),
            country: dataCountry,
            linerId: Number(selectedLinerId),
            // linerBlFileName: selectedLinerAttachmentName,
            // linerBlFileServerPath: selectedLinerFileServerPath[0],
            documents: selectedLinerAttachmentName
                ? [
                    {
                        fileName: selectedLinerAttachmentName,
                        filePath: selectedLinerFileServerPath?.[0],
                        attachmentId: linerAttachmentId
                    }
                ]
                : [],
            payorRegisteredEmail: watch("registeredEmailAddress"),
            // payorRegisteredEmail: payorRegisteredEmailArray,
            linerRemarks: watch("linerRemarks"),
            releaseToCustomer: watch("releaseToCustomer"),
            actionType: "Completed"
        };

        console.log(payload, "approverejectpayload");
        // dispatch(approvereject(payload))
        //     .unwrap()
        //     .then((result: any) => {
        //         toast.success(result.responseMsg);
        //         navigate('/exportBlDashboard')
        //         dispatch(updateDashbaordRefresh(true));
        //     })
        //     .catch((e: any) => {
        //         console.error("Failed to approve:", e);
        //     });

        dispatch(approvereject(payload))
            .unwrap()
            .then((result: any) => {
                toast.success(result.responseMsg);
                navigate('/exportBlDashboard');
                dispatch(updateDashbaordRefresh(true));
            })
            .catch((err: any) => {
                toast.error(err?.responseMsg || 'Something went wrong');
            });

    };

    const handleReject = async () => {
        setValue("actionType", "R");
        setValue("lockerPin", "");
        setValue("lockerUnit", "");
        setValue("releaseToCustomer", "N");
        setValue("registeredEmailAddress", "");
        setValue("validTill", "");
        dispatch(updateSelectedLinerDocId({}))
        dispatch(updateSelectedLinerAttachmentFilePath(null))
        dispatch(updateLinerAttachmentId(null))
        dispatch(updateSelectedLinerFileServerPath([]))
        dispatch(updateSelectedLinerAttachmentName(null))
        setLoadingLinerFileState(undefined)
        await new Promise((resolve) => setTimeout(resolve, 0));
        trigger(["linerRemarks"]);
        clearErrors(["lockerPin", "lockerUnit", "registeredEmailAddress", "validTill"]);

        const isValid = await trigger(["linerRemarks"]);
        if (!isValid) return;

        const payload = {
            blId: newBlIdDecrypt,
            validTill: watch("validTill"),
            lockerPin: watch("lockerPin"),
            lockerUnit: watch("lockerUnit"),
            blCopyType: watch("blCopyType"),
            // registeredEmailAddress: watch("registeredEmailAddress"),
            payorRegisteredEmail: "",
            linerRemarks: watch("linerRemarks"),
            country: dataCountry,
            linerId: Number(selectedLinerId),
            actionType: "Rejected",
            documents: []

        };

        console.log(payload, "approverejectpayload");


        dispatch(approvereject(payload))
            .unwrap()
            .then((result: any) => {
                toast.success(result.responseMsg);
                navigate('/exportBlDashboard');
                dispatch(updateDashbaordRefresh(true));
            })
            .catch((err: any) => {
                toast.error(err?.responseMsg || 'Something went wrong');
            });




    };

    const handleNotify = async () => {
        // setActionType("R");
        setValue("actionType", "N");
        setValue("lockerPin", "");
        setValue("lockerUnit", "");
        setValue("releaseToCustomer", "N");
        setValue("validTill", "");
        dispatch(updateSelectedLinerDocId({}))
        dispatch(updateSelectedLinerAttachmentFilePath(null))
        dispatch(updateLinerAttachmentId(null))
        dispatch(updateSelectedLinerFileServerPath([]))
        dispatch(updateSelectedLinerAttachmentName(null))
        setLoadingLinerFileState(undefined)

        await new Promise((resolve) => setTimeout(resolve, 0));

        // Notify requires both: liner remarks + registered email address.
        clearErrors(["lockerPin", "lockerUnit", "validTill"]);
        const isValid = await trigger(["registeredEmailAddress", "linerRemarks"]);
        if (!isValid) return;

        const payload = {
            blId: newBlIdDecrypt,
            validTill: watch("validTill"),
            lockerPin: watch("lockerPin"),
            lockerUnit: watch("lockerUnit"),
            blCopyType: watch("blCopyType"),
            // registeredEmailAddress: watch("registeredEmailAddress"),
            payorRegisteredEmail: watch("registeredEmailAddress"),
            linerRemarks: watch("linerRemarks"),
            country: dataCountry,
            linerId: Number(selectedLinerId),
            actionType: "Notified",
            documents: []

        };
        console.log(payload, "approverejectpayload");
        dispatch(approvereject(payload))
            .unwrap()
            .then((result: any) => {
                toast.success(result.responseMsg);
                navigate('/exportBlDashboard');
                dispatch(updateDashbaordRefresh(true));
            })
            .catch((err: any) => {
                toast.error(err?.responseMsg || 'Something went wrong');
            });
    };


    const {
        register,
        handleSubmit,
        control,
        setValue,
        getValues,
        reset,
        watch,
        trigger,
        clearErrors,
        formState: { errors },
    } = useForm<FormValues>({
        resolver: yupResolver(validationSchema),
        // context: { actionType },
        mode: 'onSubmit',
        defaultValues: {
            //  email: profileDetails?.email?.trim() || "",
            releaseToCustomer: "N",
            actionType: "",
            lockerUnit: "",
        }
    });
    // console.log(errors, "errors")
    const statusValue = watch("status");
    const customerEmail = watch("email");
    const releaseToCustomer = watch("releaseToCustomer");
    console.log("vv", releaseToCustomer);
    const showPinFields = releaseToCustomer === "Y";
    const isOblBlType = Number(watch("blType")) === 3;
    const pinValue = watch("lockerPin");
    const validTillValue = watch("validTill");
    console.log(showPinFields, "oo");
    const isSubmitDisabled = () => {
        if (Object.values(loadingFileState).some(
            (val) => val != 100 && val != 0 && val != -1 && val != undefined
        )) return true

        const docList = docAttachment?.list ?? [];
        if (docList.length === 0) return true;

        const hasInvalidDoc = docList
            .filter((x) => x.m)
            .some((d) => {
                const key = (d.attachmentId ?? d.rowNumber ?? "") + "";

                // 1) Name must exist
                const fileName = selectedAttachmentName?.[key]?.name;
                if (!fileName) return true;

                // 2) Path from backend (existing doc)
                const storedPath = selectedAttachmentFilePath?.[key];
                if (storedPath) {
                    // Existing document already stored → valid, no need for uploadState
                    return false;
                }

                // 3) New upload in this session
                const serverInfo = serverFilePath?.[key];      // [filePath, tempFileName] or undefined
                const serverPath = Array.isArray(serverInfo) ? serverInfo[0] : serverInfo;
                const uploadState = loadingFileState?.[key];

                // Must have a new uploaded file AND upload complete
                if (!serverPath || uploadState !== 100) {
                    return true;
                }

                return false;
            });
        if (hasInvalidDoc) return true;

        return false;
    };


    // const isSubmitDisabled = () => {

    //     if (Object.values(loadingFileState).some(
    //         (val) => val != 100 && val != 0 && val != -1 && val != undefined
    //     )) return true


    //     const docAttachmentKey = docAttachment;
    //     // const viewFormAttKey =  demurrageViewForm.attList;

    //     if (docAttachmentKey?.list?.length == 0) return true
    //     if (docAttachmentKey.list.filter((x) => x.m).findIndex(
    //         (d) => {
    //             // const key = d?.dndInstructionAttId ?? (d?.isDropDownDoc ? d?.rowNumber ?? null : null);
    //             const key = d?.dndInstructionAttId ?? d?.rowNumber ?? null;
    //             console.log(key, selectedAttachmentName?.[key], loadingFileState, serverFilePath[key])

    //             // check for file name  
    //             return (
    //                 !selectedAttachmentName?.[key]
    //                 || ((
    //                     // check for uploaded files
    //                     loadingFileState[key] !== 100
    //                     || !serverFilePath[key]
    //                 )

    //                     // check for submitted files
    //                     // && ((viewFormAttKey.findIndex((i) => (i?.docId == d?.docId)
    //                     //     && i?.dndInstructionAttId) == -1)
    //                     //     || loadingFileState[key] == -1)
    //                 ))
    //         }) != -1) return true

    // }

    const charLimit = (name: string, limit: number) =>
        name && name?.length >= limit ? name?.substring(0, limit) + '...' : name;


    const onSubmitForm = handleSubmit(async (payload) => {
        console.log("submit new bl request payload", payload, errors);
        if (isSubmitDisabled()) {
            toast.dark('Please upload Documents');
            return;
        }

        const data = {
            blRequestId: newBlIdDecrypt || null,
            // "newBlRequestId": (newBlIdDecrypt && location.pathname.includes('editvessel')) ? newBlIdDecrypt : null,
            // "newBlRequestId": null,
            "booking_no": payload?.bookingNumber ?? "",
            "bl_no": payload?.blNumber ?? "",
            // "payor_registered_email": payload.registeredEmailAddress,
            "shipment_type": payload.shipmentType || "Export",
            "bl_type": payload?.blType ?? "",
            "bl_location": payload?.blLocation ?? "",
            "agent_name": payload?.agentName ?? "",
            "agent_number": payload?.agentNumber ?? "",
            // "validTill": payload.validTill,
            // "lockerPin": payload.lockerPin,
            // "payor_email": payload?.email ?? "",
            "payor_email": getValues("email") || profileDetails?.email || "",
            "country": dataCountry,
            "linerId": Number(selectedLinerId),
            // "linerRemarks": payload.linerRemarks,
            "status": 'Submitted',

        }


        const documents = documentList
            .map(item => {
                // const rowNumber = item.rowNumber;
                const key = item?.attachmentId ?? item.rowNumber ?? null;

                // if (serverFilePath[key]) {
                return {
                    attachmentId: item.attachmentId ?? null,
                    docId: item.docId,
                    fileName: selectedAttachmentName[key]?.name,
                    // filePath: serverFilePath[key]?.[0],
                    filePath: selectedAttachmentFilePath[key],
                    tempFileName: serverFilePath[key]?.[1],
                    tempFilePath: serverFilePath[key]?.[0] 

                };
                // }

                return null; // when no file exists
            })
            


        console.log(documents, "documentabc")



        const finalPayload = {
            ...data,
            documents
        };

        dispatch(submitBlRequest(finalPayload))
            .unwrap()
            .then((result: any) => {
                toast.success(result.responseMsg)
                navigate('/exportBlDashboard')
                dispatch(updateDashbaordRefresh(true))
            })
            .catch((e: any) => {
                toast.error(e.responseMsg || 'Failed to submit BL request');
                console.error('Failed to save new BL request data:', e);
            });

    });


    const uploadDoument = (rowData: any) => {
        const { docId, attachmentId, fileName, actionBy, isVerify, rowNumber, isDropDownDoc, isDOExtensionFile } = rowData.row.original;
        console.log(rowData.row.original, "rowData.row.original12")
        // const key = dndInstructionAttId ?? (isDropDownDoc ? rowNumber ?? null : null);
        const key = attachmentId ?? rowNumber ?? null;
        const charLimit = (name: string, limit: number) =>
            name && name?.length >= limit ? name?.substring(0, limit) + '...' : name;
        if (!newBlIdDecrypt || (profileDetails.partnerType == 'customer' && isEdit && newBlIdDecrypt)) {
            return (
                <div className='d-flex justify-content-start align-items-center'>
                    <UploadThing
                        name={selectedAttachmentFilePath?.[key]
                            ? fileName
                            : selectedAttachmentName?.[key]?.name
                        }
                        loading={loadingFileState[key]}
                        disabled={!!isVerify || Object.values(loadingFileState).some(
                            (val) => val != 100 && val != -1 && val != undefined
                        ) || (isDOExtensionFile && attachmentId)}

                        fulfilled={function (name: string, serverPath: string, serverName: string): void {
                            setLoadingFileState((state: any) => {
                                return { ...state, [key]: 100 };
                            });
                            dispatch(
                                updateSelectedFileServerPath({
                                    ...serverFilePath,
                                    [key]: [serverPath, serverName],
                                })
                            );
                            dispatch(
                                updateSelectedAttachmentName({
                                    ...selectedAttachmentName,
                                    [key]: { name },
                                })
                            );
                        }}

                        failed={function (): void {
                            setLoadingFileState((state: any) => {
                                return { ...state, [key]: -1 };
                            });
                            dispatch(
                                updateSelectedAttachmentName({
                                    ...selectedAttachmentName,
                                    [key]: { name: '' },
                                })
                            );
                        }}

                        pending={function (loading: number): void {
                            setLoadingFileState((state: any) => {
                                return { ...state, [key]: loading };
                            });
                        }}

                        clear={() => {/* allowRemove is false */ }}

                        selected={function (name: string): void {
                            dispatch(
                                updateSelectedAttachmentName({
                                    ...selectedAttachmentName,
                                    [key]: { name },
                                })
                            );
                            setLoadingFileState((state: any) => {
                                return { ...state, [key]: 0 };
                            });
                            dispatch(
                                updateSelectedAttachmentFilePath({
                                    ...selectedAttachmentFilePath,
                                    [key]: null,
                                })
                            );
                        }}
                        fileLimit={10}
                        fileType={['PDF']}
                        labelWidth='250px'
                        onOpenDocument={
                            !selectedAttachmentFilePath?.[key] || !attachmentId
                                ? undefined
                                : async () => {
                                    await openDocumentInNewTab({
                                        url: '/api/edo-rest-v2/v2/common/openDocument',
                                        params: {
                                            id: encryptAndEncode(attachmentId),
                                            moduleTp: 'BL_REQUEST',
                                            linerId: encryptAndEncode(
                                                profileDetails.partnerType == 'liner'
                                                    ? profileDetails?.partnerId
                                                    : selectedLinerId
                                            ),
                                        },
                                    });
                                }
                        }
                        allowRemove={false}
                    />

                </div>
            );
        } else {
            return (
                <div className='d-flex justify-content-start align-items-center'>
                    <span
                        className='text-primary cursor-pointer'
                        onClick={async () => {
                            await openDocumentInNewTab({
                            url: '/api/edo-rest-v2/v2/common/openDocument',
                            params: {
                                id: encryptAndEncode(attachmentId),
                                moduleTp: 'BL_REQUEST',
                                linerId: encryptAndEncode(
                                profileDetails.partnerType == 'liner'
                                    ? profileDetails?.partnerId
                                    : selectedLinerId
                                ),
                            },
                            });
                        }}>
                        {charLimit(fileName, 50)}
                    </span>
                </div>
            );
        }
    };


    const TableRemoveDoc = (rowData: any) => {
        const { type, allowAccess, docId, isVerify, fileName, actionBy, isDropDownDoc, rowNumber, attachmentId } = rowData.row.original;
        //const name = 'TableVerifyDoc' + type.toString();
        if (isDropDownDoc) {
            return (
                <div className='d-flex justify-content-start align-items-center'>
                    {((!newBlIdDecrypt || (profileDetails.partnerType == 'customer' && isEdit)) && !attachmentId) && (
                        <div>
                            <Button
                                variant='falcon-warning'
                                style={{ background: 'transparent', border: 'none', boxShadow: 'none', padding: '0px' }}
                                onClick={(e: any) => {
                                    // if (!dropdownDocList || dropdownDocList.length === 0) return;
                                    dispatch(removeDocument({ rowNumber: rowNumber }));
                                    const { [rowNumber]: removedLoadingState, ...restLoadingState } = loadingFileState ?? {};
                                    const newLoadingFileState = Object.keys(restLoadingState).length > 0 ?
                                        restLoadingState : {};
                                    setLoadingFileState(newLoadingFileState)
                                }}
                                disabled={!isDropDownDoc || !!isVerify || Object.values(loadingFileState).some(
                                    (val) => val != 100 && val != -1 && val != undefined
                                ) || attachmentId}
                            // disabled={docList?.length >= 10}
                            //             disabled={profileDetails.partnerType !== 'liner' || !(accessGroupLevel[demurrageViewForm.groupLevel] == 'Y') || (demurrageViewForm.status == 'Completed' || demurrageViewForm.status?.includes('Rejected'))}
                            >
                                <FontAwesomeIcon className="me-1" icon={faTrash} />
                            </Button>
                        </div>
                    )}
                </div>
            )
        }



    };


    const docAttachmentColumns: IDataTableColumn[] = [
        {
            accessor: 'attachmentId',
            Header: 'attachmentId',
        },
        {
            accessor: 'docId',
            // Header: t("resource_2:documentName"),
            Header: 'Document Name',

            Cell: (rowData: any) => {
                const { docId, isDropDownDoc, rowNumber, isVerify, attachmentId } = rowData.row.original;
                const name = currentDocList?.find((v: any) => v?.id === docId)?.name
                return (
                    <>
                        {(isDropDownDoc && !attachmentId) ? (
                            <div className='d-flex flex-row gx3'>
                                <span className="mandatory">*</span>
                                <Form.Select
                                    onChange={(e) => {
                                        const selectedId = Number(e.target.value);
                                        const selectedOption = dropdownDocList?.find(option => option.id === selectedId);

                                        if (!selectedOption) return;

                                        dispatch(updateListByRowNumber({
                                            rowNumber: rowNumber,
                                            updatedFields: {
                                                id: selectedOption.id,
                                                name: selectedOption.name
                                            }

                                        }));
                                    }}

                                    value={docId !== null && docId !== undefined ? String(docId) : "0"}
                                    className={`fs--1 form-control form-select`}
                                    // disabled={isView}
                                    disabled={!!isVerify || Object.values(loadingFileState).some(
                                        (val) => val != 100 && val != -1 && val != undefined
                                    ) || (attachmentId)}
                                >
                                    <option value="0" disabled>
                                        Select a document
                                    </option>
                                    {dropdownDocList?.map((option: any) => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </Form.Select>

                            </div>) : (
                            <>
                                {currentDocList?.find((v: any) => v?.id === docId)?.m === true ? (
                                    <span className='mandatory'>*</span>
                                ) : (
                                    ''
                                )}
                                <span title={name || ''}>{name || ''}</span>
                            </>
                        )}
                    </>
                );
            },
            width: 200,
            maxWidth: 180,
        },
        {
            accessor: 'byteArray',
            // Header: t("resource_1:upload"),
            Header: 'Upload',

            Cell: uploadDoument,
            width: 350,
            maxWidth: 350,
        },
        {
            accessor: 'remove',
            Header: '',
            Cell: TableRemoveDoc,
            width: 50,
            maxWidth: 50,
        }
    ];


    const linerId = profileDetails.partnerType == 'liner'
        ? profileDetails?.partnerId
        : selectedLinerId

    // New BL request liner config (instruction type 817), same pattern as ReleaseInstruction.
    const linerConfig = useLinerConfig(dataCountry, selectedLinerId, 817);
    console.log(linerConfig,"pp");
    // B.L. types for which attaching a BL copy is mandatory (comma separated code ids).
    const blCopyMandatoryBlTypes = (linerConfig?.blCopyMandatoryBlTypes ?? '')
        .split(',')
        .map((v: string) => v.trim())
        .filter(Boolean);
    const blCopyMandatory = blCopyMandatoryBlTypes.includes(String(watch('blType')));






    // useEffect(() => {


    //     reset({
    //         "bookingNumber": "",
    //         "blNumber": "",
    //         "registeredEmailAddress": "",
    //         "shipmentType": "Export",
    //         "blType": "",
    //         "blLocation": "",
    //         "agentName": "",
    //         "agentNumber": "",
    //         "email": "",
    //         "linerRemarks": "",
    //         "lockerPin": "",
    //         "status": "",
    //         "validTill": null,
    //         "releaseToCustomer": "N"
    //     });


    // }, [])

    useEffect(() => {

        if (newBlIdDecrypt) {

            dispatch(getNewBlRequestDetails({ newblid: newBlIdDecrypt, country: dataCountry, linerId: selectedLinerId })).unwrap().then((data: any) => {
                console.log(data, "data123")
                setValue('bookingNumber', data?.bookingNumber);
                setValue('blNumber', data?.blNumber);
                setValue('registeredEmailAddress', data?.registeredEmailAddress || "");
                setValue('shipmentType', data?.shipmentType);
                setValue('blType', data?.blType);
                setValue('blLocation', data?.blLocation);
                setValue('agentName', data?.agentName);
                setValue('agentNumber', data?.agentNumber);
                setValue('email', data?.email);
                setValue('linerRemarks', data?.linerRemarks);
                setValue('lockerPin', data?.lockerPin);
                setValue('lockerUnit', data?.lockerUnit);
                setValue('status', data?.status);
                setValue('blCopyType', data?.blType);


                // setValue('validTill', data.validTill)
                // setValue('validTill', data?.validTill ? new Date(data?.validTill) : null);
                setValue('validTill', data?.validTill);


                // if (profileDetails.partnerType == "liner" && data?.status === "Submitted") {
                //     setValue("releaseToCustomer", "N"); // unticked initially
                // } else {
                //     setValue("releaseToCustomer", data?.releaseToCustomer || "N"); // customer or other cases
                // }

                setValue("releaseToCustomer", data?.releaseToCustomer || "N");

                // setValue('releaseToCustomer', data?.releaseToCustomer || "N");
                if (data?.attList?.length > 0) {
                    dispatch(updateAdttamentData(data?.attList));
                }

                if (data?.linerDocuments?.[0]?.filePath) {
                    setLoadingLinerFileState(100);

                    dispatch(
                        updateSelectedLinerFileServerPath([data?.linerDocuments?.[0]?.filePath, data?.linerDocuments?.[0]?.fileName])
                    );
                    dispatch(
                        updateSelectedLinerAttachmentName(data?.linerDocuments?.[0]?.fileName)
                    );
                    dispatch(
                        updateLinerAttachmentId(data?.linerDocuments?.[0]?.attachmentId)
                    );

                }

                // Show remarks popup whenever user opens the form (all cases)
            })

        }
        else {
            reset({
                "bookingNumber": "",
                "blNumber": "",
                "registeredEmailAddress": "",
                "shipmentType": "Export",
                "blType": "",
                "blLocation": "",
                "agentName": "",
                "agentNumber": "",
                // "email": "",
                "email": profileDetails?.partnerType == 'customer' ? profileDetails?.email?.trim() || '' : '',
                "linerRemarks": "",
                "lockerPin": "",
                "lockerUnit": "",
                "status": "",
                "validTill": "",
                "releaseToCustomer": "N"
            });
        }

    }, [newBlIdDecrypt, dataCountry, selectedLinerId, !docList, profileDetails.partnerType, profileDetails.email])

    // useEffect(() => {
    //     setShowLockerPin(true)
    // }, [newBlIdDecrypt])

    useEffect(() => {

        if (!dataCountry || !linerId) return
        // dispatch(getShipmentTypeList({ dataCountry: blCountry, linerId }))
        // dispatch(getShipmentTypeList({ dataCountry: "NG", linerId: "1" }))
        //     .unwrap()
        //     .then((res: any) => setShipmentTypeList(res ?? [{
        //         value: '',
        //         label: ''
        //     }]))
        //     .catch(() => setShipmentTypeList([]));

        // dispatch(getBlCopyTypeList({ dataCountry: "NG", linerId: "1" }))
        //     .unwrap()
        //     .then((res: any) => setBlCopyTypeList(res ?? [{
        //         value: '',
        //         label: ''
        //     }]))
        //     .catch(() => setBlCopyTypeList([]));

        dispatch(getBlTypeList({ dataCountry: dataCountry, linerId: linerId }))
            .unwrap()
            .then((res: any) => setBlTypeList(res ?? [{
                value: '',
                label: ''
            }]))
            .catch(() => setBlTypeList([]));


        dispatch(getBlLocationList({ dataCountry: dataCountry, linerId: linerId }))
            .unwrap()
            .then((res: any) => setBlLocationList(res ?? [{
                value: '',
                label: ''
            }]))
            .catch(() => setBlLocationList([]));

    }, [dataCountry, linerId]);

    useEffect(() => {
        setLoadingFileState({})

        dispatch(clearFields())

        dispatch(updateSelectedLinerDocId({}))
        dispatch(updateSelectedLinerAttachmentFilePath(null))
        dispatch(updateLinerAttachmentId(null))
        dispatch(updateSelectedLinerFileServerPath([]))
        dispatch(updateSelectedLinerAttachmentName(null))
        setLoadingLinerFileState(undefined)


        if (!newBlIdDecrypt) {
            // dispatch(getNewBlRequestAttConf())
            dispatch(getNewBlRequestAttConf({ country: dataCountry, liner: selectedLinerId }))
        }



    }, [newBlIdDecrypt, dataCountry, selectedLinerId]);

    // customer emsil disabled logic 

    useEffect(() => {
        if (
            profileDetails?.partnerType == 'customer' &&
            !newBlIdDecrypt && profileDetails?.email
        ) {

            console.log("first", profileDetails?.email)
            setValue("email", profileDetails?.email.trim(), {
                shouldValidate: true,
                shouldDirty: true,
            });
        }
    }, [profileDetails, newBlIdDecrypt, setValue, location]);


    console.log(watch("email"), "first123")


    const actionTypeForm = watch('actionType')


    return (
        <>
            <Card className='h-100 overflow-auto'>
                <Card.Header className='d-flex align-items-center border-bottom sticky-top bg-white'>
                    <FontAwesomeIcon
                        icon={faArrowAltCircleLeft}
                        className='text-warning cursor-pointer fa-lg mb-1 me-1'
                        onClick={() => navigate('/exportBlDashboard')}
                    />
                    <h2 className='fs-0 text-primary mb-1'>
                        {profileDetails.partnerType == 'customer' && !newBlIdDecrypt
                            ? 'New BL Request'
                            : 'BL Request Details'}
                    </h2>

                </Card.Header>

                <Card.Body>
                    <Form onSubmit={onSubmitForm} autoComplete='off'>
                        <div className='row'>
                            <div className='col-lg-4 mb-3'>
                                {/* <span className="mandatory">*</span> */}
                                <Form.Label className='fs--1'>
                                    Booking No.
                                </Form.Label>
                                <Form.Control
                                    className={`fs--1 ${errors.bookingNumber ? 'is-invalid' : ''}`}
                                    {...register("bookingNumber")}
                                    maxLength={8}
                                    // onInput={(e: any) => {
                                    //     setValue("bookingNumber", e.target.value.toUpperCase());
                                    // }}
                                    onInput={(e: any) => {

                                        const numericValue = e.target.value.replace(/\D/g, "");
                                        setValue("bookingNumber", numericValue);
                                    }}

                                    onBlur={(e) => {
                                        const trimmed = e.target.value.trim();
                                        setValue("bookingNumber", trimmed);
                                    }}
                                    disabled={!!newBlIdDecrypt && !(profileDetails.partnerType == 'customer' && isEdit)}
                                >
                                </Form.Control>
                                <div className='invalid-feedback d-block'>
                                    {errors.bookingNumber?.message?.toString()}
                                </div>
                            </div>

                            <div className='col-lg-4 mb-3'>
                                <span className="mandatory">*</span>
                                <Form.Label className='fs--1'>
                                    B/L No.
                                </Form.Label>
                                <Form.Control
                                    className={`fs--1 ${errors.blNumber ? 'is-invalid' : ''}`}
                                    {...register("blNumber")}
                                    maxLength={16}
                                    onInput={(e: any) => {
                                        const upper = e.target.value.toUpperCase();
                                        setValue("blNumber", upper);
                                    }}
                                    onBlur={async (e) => {
                                        const trimmed = e.target.value.trim();
                                        setValue("blNumber", trimmed);
                                        if (!trimmed) return;

                                        try {
                                            const result: any = await dispatch(getLatestBlRequestIdByBlNo(trimmed)).unwrap();

                                            if (result && result.blRequestId) {
                                                const encryptedId = AESEncrypt(String(result.blRequestId));
                                                navigate(`/exportBlDashboard/newBlRequest/${encryptedId}`);
                                            }
                                        } catch (err) {
                                            console.error('Failed to fetch latest BL Request ID by BL No:', err);
                                        }
                                    }}
                                    disabled={!!newBlIdDecrypt}

                                >
                                </Form.Control>
                                <div className='invalid-feedback d-block'>
                                    {errors.blNumber?.message?.toString()}
                                </div>
                            </div>

                            {/* <div className='col-lg-4 mb-3'>

                                <Form.Label className='fs--1'>
                                    Shipment Type
                                </Form.Label>
                                <Form.Group className="">
                                    <Form.Select
                                        value={watch("shipmentType")}
                                        {...register("shipmentType")}

                                        className={`fs--1`}
                                        disabled={true}
                                    >
                                        <option value=""></option>
                                      
                                        {shipmentTypeList?.map((item: any, index: any) => (
                                            <option value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </Form.Select>

                                </Form.Group>
                            </div> */}


                            {/* <div className='col-lg-4 mb-3'>
                                <Form.Label className='fs--1'>Shipment Type</Form.Label>
                            
                                <Form.Control
                                    // type="hidden"
                                    className='fs--1'
                                    {...register("shipmentType")}
                                     defaultValue="Export"
                                     value="Export"
                                     disabled={true}    
                                    
                                />
                            </div> */}

                            <div className='col-lg-4 mb-3'>
                                <Form.Label className='fs--1'>Shipment Type</Form.Label>

                                {/* Visible - user sees Export */}
                                <Form.Control
                                    className='fs--1'
                                    value="Export"
                                    disabled
                                />

                                {/* Hidden - sent to backend */}
                                <input
                                    type="hidden"
                                    {...register("shipmentType")}
                                    defaultValue="Export"
                                />
                            </div>




                            <div className='col-lg-4 mb-3'>
                                <span className="mandatory">*</span>
                                <Form.Label className='fs--1'>
                                    B/L Type
                                </Form.Label>
                                <Form.Group className="">
                                    <Form.Select
                                        value={watch("blType")}
                                        {...register("blType")}
                                        className={`fs--1 ${errors.blType ? 'is-invalid' : ''}`}
                                        isInvalid={!!errors.blType}
                                        disabled={!!newBlIdDecrypt && !(profileDetails.partnerType == 'customer' && isEdit)}
                                    >
                                        <option value=""></option>
                                        {blTypeList?.map((item: any, index: any) => (
                                            <option value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </Form.Select>

                                </Form.Group>
                                <div className='invalid-feedback d-block'>
                                    {errors.blType?.message?.toString()}
                                </div>
                            </div>

                            <div className='col-lg-4 mb-3'>
                                <span className="mandatory">*</span>
                                <Form.Label className='fs--1'>
                                    B/L Location
                                </Form.Label>
                                <Form.Group className="">
                                    <Form.Select
                                        value={watch("blLocation")}
                                        {...register("blLocation")}
                                        className={`fs--1 ${errors.blLocation ? 'is-invalid' : ''}`}
                                        isInvalid={!!errors.blLocation}
                                        disabled={!!newBlIdDecrypt && !(profileDetails.partnerType == 'customer' && isEdit)}
                                    >
                                        <option value=""></option>
                                        {blLocationList?.map((item: any, index: any) => (
                                            <option value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </Form.Select>

                                </Form.Group>
                                <div className='invalid-feedback d-block'>
                                    {errors.blLocation?.message?.toString()}
                                </div>
                            </div>

                            <div className='col-lg-4 mb-3'>
                                <span className="mandatory">*</span>
                                <Form.Label className='fs--1'>
                                    Customer’s Name
                                </Form.Label>
                                <Form.Control
                                    className={`fs--1 ${errors.agentName ? 'is-invalid' : ''}`}
                                    {...register("agentName")}
                                    disabled={!!newBlIdDecrypt && !(profileDetails.partnerType == 'customer' && isEdit)}
                                    maxLength={100}
                                    onBlur={(e) => {
                                        const trimmed = e.target.value.trim();
                                        setValue("agentName", trimmed);
                                    }}
                                >
                                </Form.Control>
                                <div className='invalid-feedback d-block'>
                                    {errors.agentName?.message?.toString()}
                                </div>
                            </div>

                            <div className='col-lg-4 mb-3'>
                                <span className="mandatory">*</span>
                                <Form.Label className='fs--1'>
                                    Customer's Contact No.
                                </Form.Label>
                                <Form.Control
                                    className={`fs--1 ${errors.agentNumber ? 'is-invalid' : ''}`}
                                    {...register("agentNumber")}
                                    maxLength={15}
                                    disabled={!!newBlIdDecrypt && !(profileDetails.partnerType == 'customer' && isEdit)}
                                    onInput={(e: any) => {
                                        // const numericValue = e.target.value.replace(/\D/g, "");
                                        const numericValue = e.target.value.replace(/[^0-9+\-\s]/g, "");
                                        setValue("agentNumber", numericValue);
                                    }}
                                    onBlur={(e) => {
                                        const trimmed = e.target.value.trim();
                                        setValue("agentNumber", trimmed);
                                    }}
                                >
                                </Form.Control>
                                <div className='invalid-feedback d-block'>
                                    {errors.agentNumber?.message?.toString()}
                                </div>
                            </div>



                            {/* <div className='col-lg-4 mb-3'>
                               
                                <Form.Label className='fs--1'>
                                    Customer Email(s)
                                </Form.Label>
                                <Form.Control
                                
                                    className={`fs--1 ${errors.email ? 'is-invalid' : ''}`}
                                    {...register("email")}
                                    disabled={!!newBlIdDecrypt}
                                    maxLength={200}
                                    onBlur={(e) => {
                                        const trimmed = e.target.value.trim();
                                        setValue("email", trimmed);
                                    }}
                                >
                                </Form.Control>
                                <div className='invalid-feedback d-block'>
                                    {errors.email?.message?.toString()}
                                </div>
                            </div> */}

                            <div className='col-lg-4 mb-3'>

                                <Form.Label className='fs--1'>
                                    Customer Email
                                </Form.Label>
                                <Form.Control

                                    className={`fs--1 ${errors.email ? 'is-invalid' : ''}`}
                                    {...register("email")}
                                    disabled={true}
                                    maxLength={200}
                                // onBlur={(e) => {
                                //     const trimmed = e.target.value.trim();
                                //     setValue("email", trimmed);
                                // }}
                                >
                                </Form.Control>
                                <div className='invalid-feedback d-block'>
                                    {errors.email?.message?.toString()}
                                </div>
                            </div>




                            {location.pathname.includes('/exportBlDashboard') && docAttachment.list && docList?.length ? (
                                <div className='col-lg-12 mt-2 mb-2 demmurageTable'>
                                    {(!newBlIdDecrypt) && <span className='badge bg-secondary mb-2'>
                                        {t('resource_message:docInfo')}{' '}
                                    </span>}
                                    {(!newBlIdDecrypt || (profileDetails.partnerType == 'customer' && isEdit)) && !!dropdownDocList?.length && (
                                        <div>
                                            <Button
                                                variant='falcon-primary'
                                                size='sm'

                                                onClick={(e: any) => {
                                                    if (!dropdownDocList || dropdownDocList.length === 0) return;


                                                    // const rowNumber = crypto.randomUUID();
                                                    // const selectedDoc = { rowNumber:rowNumber, ...dropdownDocList[0]};
                                                    if (additionalDocCount < 2) {
                                                        dispatch(addDocument({}));
                                                    }
                                                }}
                                                disabled={!dropdownDocList?.length || additionalDocCount >= 2}
                                                className=" mb-2"
                                                style={{ width: "max-content" }}
                                            >
                                                <FontAwesomeIcon className="me-1" icon={faAdd} /> Documents
                                            </Button>
                                        </div>
                                    )}
                                    {docAttachment?.list?.length > 0 &&
                                        <div className='col-lg-12 mt-2 mb-2'>
                                            <DataTable
                                                // data={docAttachment?.list ?? []}
                                                data={docAttachment?.list ?? []}
                                                gridName='NEW_BL_REQUEST_ATTACHMENT'
                                                columns={docAttachmentColumns}
                                                sortable={false}
                                                searchable={false}
                                                showColumnFilter={false}
                                                selection={false}
                                                perPage={100}
                                                pagination={false}
                                                showExport={false}
                                                uniqueFilterKey='newBlRequestAttachment'
                                                autoHeight={true}
                                                staticHiddenCols={profileDetails?.partnerType == 'liner' ? ['attachmentId', 'remove'] : ['attachmentId']}
                                            />
                                        </div>}
                                </div>
                            ) : (
                                ''
                            )}

                            {(profileDetails.partnerType == 'customer' && newBlIdDecrypt && statusValue === "Completed" && showPinFields && isOblBlType) && (
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <Form.Label style={{ color: '#f5822a' }}>
                                            <ul style={{ paddingLeft: '15px', marginBottom: '0' }}>
                                                <li> Please collect the OBL from the counter and ensure that you entered the correct locker PIN within the validity period.</li>
                                            </ul>
                                        </Form.Label>
                                    </div>
                                </div>)}



                            {/* {((profileDetails.partnerType == 'customer' && newBlIdDecrypt && showPinFields && statusValue === 'Completed') || (profileDetails.partnerType == 'liner' && newBlIdDecrypt)) && (

                                <div className='col-lg-4 mb-3'>
                                    <Form.Label className='fs--1'>
                                        PIN
                                        {validTillValue && <span className="text-danger ms-1">*</span>}
                                    </Form.Label>

                                    <input type="text" style={{ display: 'none' }} autoComplete="off" />

                                    <div className='position-relative'>
                                        <Form.Control
                                            type={showLockerPin ? "text" : "password"}
                                            className={`fs--1 ${errors.lockerPin ? 'is-invalid' : ''}`}
                                            autoComplete="new-password"
                                            {...register("lockerPin")}
                                            maxLength={10}
                                            onInput={(e: any) => {
                                                const numericValue = e.target.value.replace(/\D/g, "").slice(0, 10);
                                                setValue("lockerPin", numericValue, { shouldValidate: true });
                                            }}
                                            disabled={
                                                profileDetails.partnerType == 'customer' ||
                                                (profileDetails.partnerType == 'liner' && statusValue == "Rejected")
                                            }
                                            onBlur={(e) => {
                                                const trimmed = e.target.value.trim();
                                                setValue("lockerPin", trimmed, { shouldValidate: true });
                                            }}
                                        />
                                        <FontAwesomeIcon
                                            icon={showLockerPin ? faEye : faEyeSlash}
                                            onClick={() => setShowLockerPin(prev => !prev)}
                                            className="position-absolute"
                                            style={{
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                color: "#6c757d"
                                            }}
                                        />
                                    </div>
                                    <div className='invalid-feedback d-block'>
                                        {errors.lockerPin?.message?.toString()}
                                    </div>
                                </div>
                            )} */}


                            {(((profileDetails.partnerType == 'customer' && newBlIdDecrypt && showPinFields && statusValue === 'Completed' && isOblBlType) || (profileDetails.partnerType == 'liner' && newBlIdDecrypt)) && isOblBlType) && (

                                <div className='col-lg-4 mb-3'>
                                    <Form.Label className='fs--1'>
                                        Locker PIN
                                        <span className="mandatory">*</span>
                                       
                                    </Form.Label>

                                    <input type="text" style={{ display: 'none' }} autoComplete="off" />

                                    <div className='position-relative'>
                                        <Form.Control
                                            type='text'
                                            className={`fs--1 ${errors.lockerPin ? 'is-invalid' : ''}`}
                                            autoComplete="new-password"
                                            {...register("lockerPin")}
                                            maxLength={10}
                                            onInput={(e: any) => {
                                                const numericValue = e.target.value.replace(/\D/g, "").slice(0, 10);
                                                setValue("lockerPin", numericValue, { shouldValidate: true });
                                            }}
                                            disabled={
                                                profileDetails.partnerType == 'customer' ||
                                                (profileDetails.partnerType == 'liner' && statusValue == "Rejected")
                                            }
                                            onBlur={(e) => {
                                                const trimmed = e.target.value.trim();
                                                setValue("lockerPin", trimmed, { shouldValidate: true });
                                            }}
                                        />
                                    </div>
                                    <div className='invalid-feedback d-block'>
                                        {errors.lockerPin?.message?.toString()}
                                    </div>
                                </div>
                            )}



                            {(((profileDetails.partnerType === 'customer' && newBlIdDecrypt && showPinFields && statusValue === 'Completed' && isOblBlType) || (profileDetails.partnerType == 'liner' && newBlIdDecrypt)) && isOblBlType) && (
                                <div className='col-lg-4 mb-3' >
                                    <Form.Label className='fs--1'>
                                        
                                        PIN Validity (In Hours)
                                        <span className="mandatory">*</span>
                                    </Form.Label>
                                    {/* <Controller
                                        control={control}
                                        name='validTill'
                                        render={({ field }) => (
                                            <DatePicker
                                                portalId='root-portal'
                                                onChange={(date: any) => {
                                                    field.onChange(date)
                                                }}

                                                className={`fs--1 form-control ${!!errors.validTill ? 'is-invalid' : ''}`}
                                                // disabled={isView}
                                                selected={getValues("validTill") ?? null}
                                                dateFormat={getDateFormat()}
                                                isClearable={clearable}
                                                popperProps={{
                                                    strategy: 'fixed',
                                                }}
                                                minDate={new Date()}
                                                // disabled={!!newBlIdDecrypt}
                                                disabled={
                                                    profileDetails.partnerType == 'customer' ||
                                                    (profileDetails.partnerType == 'liner' && statusValue == "Rejected")
                                                }
                                            />
                                        )}
                                    /> */}
                                    <Form.Control
                                       
                                        {...register("validTill")}
                                        // className='fs--1'
                                        className={`fs--1 ${errors.validTill ? 'is-invalid' : ''}`}
                                        // rows={2}
                                        maxLength={100}
                                        onBlur={(e) => {
                                            const trimmed = e.target.value.trim();
                                            setValue("validTill", trimmed);
                                        }}

                                        disabled={
                                            profileDetails.partnerType == 'customer' ||
                                            (profileDetails.partnerType == 'liner' && statusValue == "Rejected")
                                        }


                                    >
                                    </Form.Control>
                                    <div className='invalid-feedback d-block'>
                                        {errors.validTill?.message?.toString()}
                                    </div>
                                </div>
                            )}

                          


                            {(((profileDetails.partnerType === 'customer' && newBlIdDecrypt && showPinFields && statusValue === 'Completed' && isOblBlType) || (profileDetails.partnerType == 'liner' && newBlIdDecrypt)) && isOblBlType) && (
                                <div className='col-lg-4 mb-3'>
                                    <Form.Label className='fs--1'>
                                        Locker Unit
                                        <span className="mandatory">*</span>
                                    </Form.Label>
                                    <Form.Control
                                    as="textarea"
                                        className={`fs--1 ${errors.lockerUnit ? 'is-invalid' : ''}`}
                                        {...register("lockerUnit")}
                                        maxLength={500}
                                        disabled={
                                            profileDetails.partnerType == 'customer' ||
                                            (profileDetails.partnerType == 'liner' && statusValue == "Rejected")
                                        }
                                        onBlur={(e) => {
                                            setValue("lockerUnit", e.target.value.trim(), { shouldValidate: true });
                                        }}
                                    />
                                    <div className='invalid-feedback d-block'>
                                        {errors.lockerUnit?.message?.toString()}
                                    </div>
                                </div>
                            )}

                            {/* {!(profileDetails.partnerType === 'customer' && !newBlIdDecrypt) && ( */}
                            {(
                                (
                                    profileDetails.partnerType == 'customer' &&
                                    newBlIdDecrypt &&
                                    (statusValue === 'Completed' || statusValue === 'Rejected' || statusValue === 'Notified')
                                ) ||
                                (
                                    profileDetails.partnerType == 'liner' &&
                                    newBlIdDecrypt
                                )
                            ) && (
                                    <div className='col-lg-4 mb-3'>
                                        {profileDetails.partnerType == 'liner' && actionTypeForm === 'R' && (
                                            <span className="mandatory">*</span>
                                        )}
                                        <Form.Label className='fs--1'>
                                            Liner Remarks
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            {...register("linerRemarks")}
                                            // className='fs--1'
                                            className={`fs--1 ${errors.linerRemarks ? 'is-invalid' : ''}`}
                                            rows={2}
                                            maxLength={500}
                                            onBlur={(e) => {
                                                const trimmed = e.target.value.trim();
                                                setValue("linerRemarks", trimmed);
                                            }}
                                            disabled={
                                                profileDetails.partnerType == 'customer'
                                            }
                                        // disabled={
                                        //     profileDetails.partnerType == 'customer' ||
                                        //     (profileDetails.partnerType == 'liner' && statusValue == "Rejected")
                                        // }


                                        >
                                        </Form.Control>
                                        <div className='invalid-feedback d-block'>
                                            {errors.linerRemarks?.message?.toString()}
                                        </div>
                                    </div>
                                )}


                            {(profileDetails.partnerType == 'liner' && newBlIdDecrypt) && (
                                <div className="col-lg-12 mb-3">
                                    <div className="border rounded p-3 mb-3" style={{ borderColor: '#dee2e6', backgroundColor: '#f8f9fa' }}>
                                        <div className="row">
                                            <div className='col-lg-5 mb-3'>
                                                {/* {profileDetails.partnerType === 'liner' && actionType === 'A' && (
                                                    <span className="mandatory">*</span>
                                                )} */}
                                                <Form.Label className='fs--1'>
                                                    BL Type
                                                </Form.Label>
                                                <Form.Group className="">
                                                    <input type='hidden' {...register("blCopyType")} />
                                                    <Form.Select
                                                        // {...register("blCopyType")}

                                                        className={`fs--1 ${errors.blCopyType ? 'is-invalid' : ''}`}
                                                        isInvalid={!!errors.blCopyType}
                                                        value={watch("blCopyType")}
                                                        disabled={true}
                                                    >
                                                        <option value=""></option>
                                                        {blTypeList?.map((item: any, index: any) => (
                                                            <option value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                    <div className='invalid-feedback d-block'>
                                                        {errors.blCopyType?.message?.toString()}
                                                    </div>
                                                </Form.Group>
                                            </div>
                                            {(profileDetails?.partnerType == 'liner') && (
                                                <div className='col-lg-6 mb-3'>
                                                    <Form.Group controlId='tableComponent.input5'>
                                                        <Form.Label className='fs--1 d-flex flex-row'>
                                                            {/* {isMandatory == 'Y' ? <span className='mandatory'>*</span> : ''} */}
                                                            {profileDetails.partnerType == 'liner' && actionTypeForm === 'A' && blCopyMandatory && (
                                                                <span className="mandatory">*</span>
                                                            )}
                                                            {(profileDetails.partnerType == 'liner' &&
                                                                (statusValue === 'Submitted' || statusValue === 'Notified'))
                                                                ? 'Attach BL File'
                                                                : 'Uploaded Document'}
                                                        </Form.Label>

                                                        {(newBlIdDecrypt && profileDetails?.partnerType == 'liner' && (statusValue === 'Submitted' || statusValue === 'Notified')) ?
                                                            (
                                                                <>
                                                                    <UploadThing
                                                                        name={selectedLinerAttachmentFilePath
                                                                            ? selectedLinerAttachmentName
                                                                            : selectedLinerAttachmentName
                                                                        }
                                                                        loading={loadingLinerFileState ?? 0}
                                                                        disabled={
                                                                            // (profileDetails?.partnerType === 'customer') || 

                                                                            (loadingLinerFileState != 100 && loadingLinerFileState != -1 && loadingLinerFileState != undefined)
                                                                        }

                                                                        fulfilled={function (name: string, serverPath: string, serverName: string): void {
                                                                            setLoadingLinerFileState(100);
                                                                            dispatch(
                                                                                updateSelectedLinerFileServerPath([serverPath, serverName])
                                                                            );
                                                                            dispatch(
                                                                                updateSelectedLinerAttachmentName(name)
                                                                            );
                                                                            // clearErrors('loiUpload');
                                                                        }}

                                                                        failed={function (): void {
                                                                            setLoadingLinerFileState(-1);
                                                                            dispatch(
                                                                                updateSelectedLinerAttachmentName('')
                                                                            );
                                                                            // setError('loiUpload', {
                                                                            //     type: 'manual',
                                                                            //     message: 'File upload failed or is required',
                                                                            // });
                                                                        }}

                                                                        pending={function (loading: number): void {
                                                                            setLoadingLinerFileState(loading);
                                                                        }}

                                                                        clear={() => {/* allowRemove is false */ }}

                                                                        selected={function (name: string): void {
                                                                            dispatch(
                                                                                updateSelectedLinerAttachmentName(name)
                                                                            );
                                                                            setLoadingLinerFileState(0);
                                                                            dispatch(
                                                                                updateSelectedLinerAttachmentFilePath(null)
                                                                            );
                                                                            dispatch(
                                                                                updateLinerAttachmentId(null)
                                                                            );

                                                                        }}
                                                                        fileLimit={10}
                                                                        fileType={['PDF']}
                                                                        labelWidth='250px'
                                                                        onOpenDocument={
                                                                            !selectedLinerAttachmentFilePath || !linerAttachmentId
                                                                                ? undefined
                                                                                : async () => {
                                                                                    await openDocumentInNewTab({
                                                                                        url: '/api/edo-rest-v2/v2/common/openDocument',
                                                                                        params: {
                                                                                            id: encryptAndEncode(linerAttachmentId),
                                                                                            moduleTp: 'BL_REQUEST',
                                                                                            linerId: encryptAndEncode(
                                                                                                profileDetails.partnerType == 'liner'
                                                                                                    ? profileDetails?.partnerId
                                                                                                    : selectedLinerId
                                                                                            ),
                                                                                        },
                                                                                    });
                                                                                }
                                                                        }
                                                                        allowRemove={false}
                                                                    />

                                                                    {/* <div className='fs--1 is-invalid mandatory m-0 p-0'>
                                                        {errors.loiUpload?.message?.toString()}
                                                    </div> */}

                                                                </>
                                                            ) : (
                                                                <div className='d-flex justify-content-start align-items-center'>

                                                                    <span
                                                                        className='text-primary cursor-pointer fs--1'
                                                                        onClick={async () => {
                                                                            await openDocumentInNewTab({
                                                                            url: '/api/edo-rest-v2/v2/common/openDocument',
                                                                            params: {
                                                                                id: encryptAndEncode(linerAttachmentId),
                                                                                moduleTp: 'BL_REQUEST',
                                                                                linerId: encryptAndEncode(
                                                                                profileDetails.partnerType == 'liner'
                                                                                    ? profileDetails?.partnerId
                                                                                    : selectedLinerId
                                                                                ),
                                                                            },
                                                                            });
                                                                        }}>
                                                                        {charLimit(selectedLinerAttachmentName, 70)}
                                                                    </span>
                                                                </div>
                                                            )
                                                        }
                                                    </Form.Group>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>)}



                            {!(profileDetails.partnerType == 'customer') && (
                                <div className='col-lg-12 mb-3'>
                                    <Form.Check
                                        type="checkbox"
                                        // label="Click here to use Payor Email as Registered Email Address"

                                        label={<>
                                            Release the BL to the customer’s email{" "}
                                            <strong>{customerEmail || "auto-populated"}</strong>{" "}
                                            at ODeX
                                        </>}
                                        checked={watch("releaseToCustomer") === "Y"}
                                        className="mb-2 text-nowrap"
                                        disabled={!(statusValue === "Submitted" || statusValue === "Rejected" || statusValue === "Notified")}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                const emailValue = watch("email") || "";
                                                setValue("registeredEmailAddress", emailValue, { shouldDirty: true });
                                                setValue("releaseToCustomer", "Y", { shouldDirty: true });
                                            } else {
                                                setValue("releaseToCustomer", "N", { shouldDirty: true });
                                                setValue("registeredEmailAddress", "");
                                                // setValue("registeredEmailAddress", data?.registeredEmailAddress || "");
                                            }
                                            setIsRegisteredEmailDisabled(e.target.checked);
                                        }}
                                    />


                                    {/* Label above input */}
                                    {profileDetails.partnerType == 'liner' && actionTypeForm === 'A' && (
                                        <span className="mandatory">*</span>
                                    )}
                                    <Form.Label className='fs--1 mb-1'>
                                        Registered Email Address
                                    </Form.Label>

                                    {/* Input field */}
                                    <div className='col-lg-6 mb-3'>


                                        <Form.Control
                                            className={`fs--1 ${errors.registeredEmailAddress ? 'is-invalid' : ''}`}
                                            isInvalid={!!errors.registeredEmailAddress}
                                            maxLength={200}
                                            {...register("registeredEmailAddress")}
                                            onChange={(e) => {
                                                // update value AND trigger validation
                                                setValue("registeredEmailAddress", e.target.value, {
                                                    shouldValidate: true,  // triggers Yup validation instantly
                                                    shouldDirty: true
                                                });
                                            }}
                                            onBlur={(e) => {
                                                // const trimmed = e.target.value.trim();
                                                const normalized = e.target.value
                                                    .split(",")
                                                    .map((email) => email.trim()) // trim each email
                                                    .join(",");
                                                setValue("registeredEmailAddress", normalized);
                                            }}
                                            disabled={profileDetails.partnerType == 'customer' || isRegisteredEmailDisabled ||
                                                !(
                                                    statusValue === "Submitted" ||
                                                    statusValue === "Notified" ||
                                                    statusValue === "Rejected"
                                                )
                                            }
                                        />

                                        <div className='invalid-feedback d-block'>
                                            {errors.registeredEmailAddress?.message?.toString()}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {!(profileDetails.partnerType == 'customer' && !newBlIdDecrypt) && (
                                <div className='col-lg-4 mb-3'>
                                    <Form.Label className='fs--1'>
                                        Status
                                    </Form.Label>
                                    <Form.Control
                                        className={`fs--1`}
                                        {...register("status")}
                                        disabled={true}
                                        maxLength={50}
                                    >
                                    </Form.Control>

                                </div>)}


                        </div>

                        <div className='d-flex justify-content-center align-items-center'>
                            {!(
                                (profileDetails.partnerType == 'customer' && !!newBlIdDecrypt) ||
                                profileDetails.partnerType == 'liner'
                            ) && (
                                    <Button
                                        className='me-2'
                                        variant='falcon-primary'
                                        size='sm'
                                        data-placement="left"
                                        data-toggle="tooltip"
                                        onClick={onSubmitForm}
                                        style={{ marginRight: '0.5rem', position: 'relative' }}
                                        onChange={() => { }}
                                        disabled={false}

                                    >
                                        <FontAwesomeIcon icon={faSave} className='mx-1 me-2 mt-1 text-warning' />
                                        <span>Submit</span>
                                    </Button>
                                )}

                            {profileDetails.partnerType === 'customer' &&
                                !!newBlIdDecrypt &&
                                (statusValue === 'Rejected' || statusValue === 'Notified' || statusValue === 'Submitted') && (
                                    <Button
                                        className='me-2'
                                        variant='falcon-primary'
                                        size='sm'
                                        data-placement="left"
                                        data-toggle="tooltip"
                                        onClick={() => {
                                            if (isEdit) {
                                                onSubmitForm();
                                            } else {
                                                setIsEdit(true);
                                            }
                                        }}
                                        style={{ marginRight: '0.5rem', position: 'relative' }}
                                        onChange={() => { }}
                                        disabled={false}
                                    >
                                        <FontAwesomeIcon icon={isEdit ? faSave : faEdit} className='mx-1 me-2 mt-1 text-warning' />
                                        <span>{isEdit ? 'Save' : 'Edit'}</span>
                                    </Button>
                                )}

                            <div className="d-flex justify-content-center align-items-center gap-3">
                                {profileDetails.partnerType == 'liner' && newBlIdDecrypt && statusValue !== 'Rejected' && (
                                    <Button variant="success" size="sm" className="px-4 approve"
                                        onClick={handleApprove}
                                    >
                                        <FontAwesomeIcon icon={faCheck} className="me-2 approve" />
                                        {/* Approve */}
                                        {statusValue === "Completed" ? "Save" : "Approve"}
                                    </Button>)}

                                {profileDetails.partnerType == 'liner' && newBlIdDecrypt && (statusValue === 'Submitted' || statusValue === 'Notified') && (
                                    <Button variant="danger" size="sm" className="px-4 reject"
                                        onClick={handleReject}
                                    >
                                        <FontAwesomeIcon icon={faTimes} className="me-2 reject" />
                                        Reject
                                    </Button>)}

                                {profileDetails.partnerType === 'liner' &&
                                    newBlIdDecrypt &&
                                    (statusValue === 'Submitted' || statusValue === 'Rejected') && (

                                        <Button
                                            variant="warning"
                                            size="sm"
                                            className="px-4 notify"
                                            onClick={handleNotify}
                                        >
                                            <FontAwesomeIcon icon={faBell} className="me-2 notify" />
                                            Notify
                                        </Button>
                                    )}

                            </div>


                        </div>
                    </Form>
                </Card.Body>
            </Card>

        </>
    )
};

export default NewBlRequest;